import { render, staticRenderFns } from "./LeituraMateriais.vue?vue&type=template&id=41bad502&scoped=true&"
import script from "./LeituraMateriais.vue?vue&type=script&lang=js&"
export * from "./LeituraMateriais.vue?vue&type=script&lang=js&"
import style0 from "./LeituraMateriais.vue?vue&type=style&index=0&id=41bad502&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bad502",
  null
  
)

export default component.exports